export const settingsMenuTestIDs = {
  account: 'settings_menu_account',
  accountLabel: 'settings_menu_account_label',
  locations: 'settings_menu_locations',
  locationsLabel: 'settings_menu_locations_label',
  alerts: 'settings_menu_alerts',
  alertsLabel: 'setting_menu_alerts_label',
  closedCaptioning: 'settings_menu_closed_captioning',
  closedCaptioningLabel: 'setting_menu_closed_captioning_label',
  help: 'settings_menu_help',
  helpLabel: 'settings_menu_help_label',
  privacyLegal: 'settings_menu_privacy_legal',
  privacyLegalLabel: 'settings_menu_privacy_legal_label',
  signOut: 'settings_menu_sign_out',
  signOutLabel: 'settings_menu_sign_out_label',
  debug: 'settings_menu_debug_menu',
  debugLabel: 'settings_menu_debug_menu_label',
};
